import { COLLABORATORS_HOME_ROUTE, PLAN_ROUTE, REQUEST_TABLE_ROUTE } from './auth';
import { ACTIVITY_MILESTONE_ICON, BILLING_ICON, CLOCK_ICON, EMPLOYEES_ICON, PLAN_ICON } from './images';
import {
  QUICK_ACCESS_COLLABORATORS,
  QUICK_ACCESS_DOWNLOAD_REPORT,
  QUICK_ACCESS_PAYMENT,
  QUICK_ACCESS_PLAN,
  QUICK_ACCESS_REQUESTS
} from './tagManager';
import { TRANSLATIONS_HOME } from '../translations/home';

export const SIZE_SM = 16;
export const SIZE_MD = 20;
export const SIZE_LG = 24;

export const ICON_SIZE_PX = {
  sm: SIZE_SM,
  md: SIZE_MD,
  lg: SIZE_LG
};

export const ICON_SIZE_PX_NE = {
  s: SIZE_SM,
  m: SIZE_MD,
  l: SIZE_LG
};

export const ACCESS_DIRECT_REDIRECT_BUTTONS = [
  {
    description: TRANSLATIONS_HOME.quickAccess.collaborators,
    icon: EMPLOYEES_ICON,
    redirectLink: COLLABORATORS_HOME_ROUTE,
    id: QUICK_ACCESS_COLLABORATORS
  },
  {
    description: TRANSLATIONS_HOME.quickAccess.plan,
    icon: PLAN_ICON,
    redirectLink: PLAN_ROUTE,
    id: QUICK_ACCESS_PLAN
  }
];

export const ACCESS_TO_REPORTS = {
  icon: ACTIVITY_MILESTONE_ICON,
  id: QUICK_ACCESS_DOWNLOAD_REPORT
};

export const ACCESS_DIRECT_PAYMENT = {
  description: TRANSLATIONS_HOME.quickAccess.billing,
  icon: BILLING_ICON,
  id: QUICK_ACCESS_PAYMENT
};

export const ACCESS_REQUESTS = {
  description: TRANSLATIONS_HOME.quickAccess.requests,
  icon: CLOCK_ICON,
  id: QUICK_ACCESS_REQUESTS,
  redirectLink: REQUEST_TABLE_ROUTE
};
